import { User } from "app/core/user/user.types";

export const environment = {
    user: {} as User,
    //sso:'http://sso.aims.gov.lk/',
    sso:'https://sso.pub.dev.rims.public.icloudbay.com/',
    realm: 'if',
    clientId: 'web_app',
    ver: 'v0.0.53'


};
